export default "__VITE_ASSET__o7cItBiL__"